"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteBasketItemRequest = void 0;
const getBasket_1 = require("../../endpoints/basket/getBasket");
function deleteBasketItemRequest(params) {
    return {
        method: 'DELETE',
        endpoint: `baskets/${params.basketKey}/items/${params.itemKey}`,
        params: Object.assign(Object.assign(Object.assign(Object.assign({}, (params.with
            ? { with: (0, getBasket_1.basketWithQueryParameter)(params.with).join(',') }
            : undefined)), (params.campaignKey ? { campaignKey: params.campaignKey } : undefined)), (params.skipAvailabilityCheck
            ? { skipAvailabilityCheck: params.skipAvailabilityCheck }
            : undefined)), (params.includeItemsWithoutProductData
            ? {
                includeItemsWithoutProductData: params.includeItemsWithoutProductData,
            }
            : undefined)),
    };
}
exports.deleteBasketItemRequest = deleteBasketItemRequest;
